import ResponseHandler from '~/utils/response-handler'
import $ from 'jquery'
import _ from 'lodash'

let fn = function(vue_component, form_ref_name, form_object, scroll_container = "body") {
    this.vue_component = vue_component;
    this.form_object = vue_component.form;
    if(form_object){
        this.form_object = form_object;
    }
    this.form_component;
    this.form = null;
    this.target_url = null;
    this.method = "POST";
    this.dataType = "json";
    this.pauseSubmit = false;
    this.scroll_container = scroll_container;
    this.UI = {
        'submit': null
    };
    this.additionalParams = [];
    this.returnData = null;
    //
    this.init(vue_component, form_ref_name);
};

fn.prototype = {
    'init': function(vue_component, form_ref_name) {
        this.form_component = vue_component.$refs[form_ref_name];

        if(this.form_component === undefined){
            console.error('invalid form ref value');
            return;
        }
        let form = $(vue_component.$refs[form_ref_name].$el);

        this.form = form;
        let tmp = form.attr("action").trim();
        let pos = -1;
        if(/\?.*$/g.test(tmp)) {
            pos = tmp.indexOf("?");
        }

        let obj = {};

        if(pos > -1) {
            let url_query = tmp.substr(pos+1);
            if(url_query){
                obj = JSON.parse('{"' + decodeURI(url_query).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}');
                tmp = tmp.substr(0, pos);
            }
        }

        obj.json = 1;
        this.target_url = tmp + "?" + $.param( obj );

        let method = form.attr("method");
        this.method = method === "" ? this.method : method;

        // define the UI variables
        this.UI.submit = this.form.find('input[type="submit"], button[type="submit"]');
        if(this.UI.submit.length===0)
            this.UI.submit = $('#submit_btn');

        this.bindEvents();
    },
    'formReset': function() {
        // clear the error messages from backend
        this.clearErrors();

        // this function will clear the error messages (from frontend rules) but also clear the input value
        this.form_component.reset();
    },
    'getData': function() {
        let data = this.form.serializeArray();
        // data = _.extend(data, this.additionalParams);
        data = _.concat(data, this.additionalParams);

        data._ajax = 1;
        return data;
    },
    'addAdditionalParam': function(name, value) {
        this.additionalParams.push({
            name: name,
            value: value
        });
    },
    'disableActions': function() {
        if (this.form_object && this.form_object.loading !== true) {
            this.form_object.loading = true;
        } else {
            this.vue_component.loading = true;
        }
    },
    'enableActions': function() {
        if (this.form_object && this.form_object.loading !== false) {
            this.form_object.loading = false;
        } else {
            this.vue_component.loading = false;
        }
    },
    'bindEvents': function() {
        let me = this;

        this.UI.submit.bind('click', function(e){
            e.preventDefault();
            if(me.pauseSubmit) return;
            if(me.form_component.$listeners && me.form_component.$listeners.before_submit){
                me.form_component.$listeners.before_submit();
            }
            me.postData();
        });
    },
    'clearErrors': function() {
        let me = this;
        let component_errors_object = me.vue_component.errors;
        if(component_errors_object === undefined){
            if(me.form_object && me.form_object.errors){
                component_errors_object = me.form_object.errors;
            }
        }
        if(component_errors_object){
            _.each(component_errors_object, function(item, key){
                component_errors_object[key] = "";
            });
        }
    },
    'postData': function(){
        let me = this;
        $.ajax({
            'url': me.target_url,
            'data': me.getData(),
            'type': me.method,
            'dataType': me.dataType,
            'xhrFields': {
                withCredentials: true
            },
            'beforeSend': function() {
                me.clearErrors();
                me.disableActions();
            },
            'complete': function(jqXHR, textStatus) {
                switch(textStatus) {
                    case "success":
                        // do nth, let success event to handle
                        break;
                }

                me.enableActions();

                let status = jqXHR.status.toString();

                if(status.match(/^3/g)) {
                    let redirect = jqXHR.getResponseHeader('X-Redirect');
                    if(redirect != null && redirect !== "") {
                        window.location.href = redirect;
                    }
                }

                // clear the additional params after the request was finished
                me.additionalParams = [];
            },
            'success': function(json, textStatus, jqXHR) {

                new ResponseHandler(json, {
                    'success': function(data){
                        me.returnData = json;
                        me.form.trigger('success_event');

                        if(me.form_component.$listeners && me.form_component.$listeners.success){
                            me.form_component.$listeners.success(json.data);
                        }

                        // let result_data = data;
                        // if(result_data.hasOwnProperty("type") && result_data.type !== undefined && result_data.type == "html" && result_data.hasOwnProperty("html") && result_data.html != undefined) {
                        //     let html = result_data.html;
                        //     $('html').html(result_data.html);
                        // } else {
                        //     me.enableActions();
                        // }
                    } ,
                    'warning': function(data) {
                        if(me.form_component.$listeners && me.form_component.$listeners.warning){
                            me.form_component.$listeners.warning(json.data);
                        }
                    },
                    'error': function(data){
                        me.processErrors(json.errors);
                        me.form.trigger('error_event');
                        me.enableActions();
                    }
                });

            },
            'error': function() {

            }
        })
    },
    'processErrors': function(errors) {
        let me = this;
        let vue_component = me.vue_component;
        let component_errors_object = vue_component.errors;
        if(component_errors_object === undefined){
            if(me.form_object && me.form_object.errors){
                component_errors_object = me.form_object.errors;
            }
        }
        let first_iteration = true;
        for(let field in errors) {
            // process only if the object has its own property
            if(errors.hasOwnProperty(field)) {
                let error = errors[field];

                let error_items = error['errors'];
                _.each(error_items, function(item){
                    if(component_errors_object !== undefined){
                        if(component_errors_object[field] !== undefined){
                            component_errors_object[field] = item.msg;
                            if(first_iteration){
                                // vue_component.$nextTick(() => vue_component.$refs.title.focus());
                                // this.$scrollTo(element, duration, options)
                                if(vue_component.$refs[field]){

                                    let el;
                                    if(vue_component.$refs[field].length){
                                        el = vue_component.$refs[field][0]
                                    } else {
                                        el = vue_component.$refs[field].$el;
                                    }

                                    console.log('ref', vue_component.$refs[field]);
                                    console.log('el', el);

                                    vue_component.$scrollTo(el, {
                                        container: me.scroll_container,
                                        offset: -100,
                                    });
                                    first_iteration = false;
                                }
                            }
                        }
                    }
                });
            }
        }
    }
};

export default fn;